module.exports = __webpack_public_path__ + "static/media/loginbgi.30a22287.png";